<app-reviews-buckets
    [context]="context"
    [data]="data$ | async"
    [preSelectedBuckets]="preSelectedBuckets"
    (filterChange)="onFilterChange($event)"
    [type]="bucketsType$ | async"
></app-reviews-buckets>
